// 跳转到出入库编辑页、详情页
import user from '@/store/user/index'
export const toWarehouse = {
  methods: {
    // 跳转出入库编辑页
    toWarehouseEdit (code, nature, finishYocType, taskType, warehouseCode) {
      // 出库 - 新版查看详情（开启生产日期或货位）
      if ((nature === 1 || nature === 3) && finishYocType === 1) {
        return this.$router.push('/assignmentManage/warehouseOutEdit/' + code + '/' + nature)
      }
      // 出库、入库 - 旧版查看详情
      this.$router.push('/assignmentManage/warehouseIntoEdit/' + code + '/' + nature + '/' + taskType + '/' + warehouseCode)
    },
    // 跳转出入库详情页
    toWarehouseDetail (code, nature, finishYocType) {
      // 出库 - 新版查看详情（开启生产日期或货位）
      if ((nature === 1 || nature === 3) && finishYocType === 1) {
        return this.$router.push('/assignmentManage/warehouseOutDetail/' + code + '/' + nature)
      }
      // 出库、入库 - 旧版查看详情
      this.$router.push('/assignmentManage/warehouseIntoDetail/' + code + '/' + nature)
    }
  },
  computed: {
    userinfo () {
      return user.state.userinfo
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/toWarehouse.js